import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e1126e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container relative" }
const _hoisted_2 = { class: "mb-60 mb-xs-40" }
const _hoisted_3 = { href: "/news/announcements" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6 col-md-4 mb-60 mb-xs-40" }
const _hoisted_6 = { class: "post-prev-img" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "post-prev-title" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "post-prev-info" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock me-2" }, null, -1 /* HOISTED */))
const _hoisted_13 = { class: "post-prev-text" }
const _hoisted_14 = { class: "post-prev-more" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 0 }

import WithLoadingPromise from './loading/WithLoadingPromise.vue'
import { ref } from 'vue'
import useNOIRLabArchives from '@/js/composables/useNOIRLabArchives'
import { announcementsApi } from '@/js/api'
import { AnnouncementMini } from '@/js/api-client'

interface Props {
  count?: number
  program: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LatestAnnouncements',
  props: {
    count: { default: 3 },
    program: null
  },
  setup(__props: any) {

const props = __props as { count: number, program: string };



const announcements = ref<AnnouncementMini[]>([])
const { formatDate } = useNOIRLabArchives()

async function loadAnnouncements() {
  const { data } = await announcementsApi.announcementsList({ program: props.program })
  announcements.value = data.results?.slice(0, props.count) || []
}

function truncateChars(text: string | undefined, length: number) {
  return text && text.length > length ? text.slice(0, length) + '...' : text
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WithLoadingPromise, {
    "async-function": loadAnnouncements,
    class: "page-section"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.window.gettext('Announcements')), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announcements.value, (announcement) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  href: `/announcements/${announcement.id}`,
                  tabindex: "-1"
                }, [
                  _createElementVNode("img", {
                    src: announcement.main_image.formats.thumb350x,
                    alt: announcement.title,
                    class: "wow scaleOutIn",
                    "data-wow-duration": "1.2s",
                    style: {"height":"210px !important","object-fit":"cover"}
                  }, null, 8 /* PROPS */, _hoisted_8)
                ], 8 /* PROPS */, _hoisted_7)
              ]),
              _createElementVNode("h3", _hoisted_9, [
                _createElementVNode("a", {
                  href: `/announcements/${announcement.id}`,
                  class: "text-lines-3",
                  style: {"height":"86px"}
                }, _toDisplayString(announcement.title), 9 /* TEXT, PROPS */, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(_toDisplayString(_unref(formatDate)(announcement.release_date)), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(truncateChars(announcement.subtitle, 200)), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("a", {
                  href: `/announcements/${announcement.id}`,
                  class: "text-link",
                  tabindex: "-1"
                }, _toDisplayString(_ctx.window.gettext('Read More')), 9 /* TEXT, PROPS */, _hoisted_15)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          (announcements.value.length === 0)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_16, _toDisplayString(_ctx.window.gettext('There are no announcements')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})